export default __webpack_public_path__ + "static/media/transparentBackground.6dc9264f.jpeg";